import { render } from "./KnittingProjects.vue?vue&type=template&id=89cd8f6e"
import script from "./KnittingProjects.vue?vue&type=script&lang=js"
export * from "./KnittingProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__